import type { FC, ReactNode } from 'react';
import { useCallback, useEffect, useState } from 'react';

import { URI_CONFIG } from 'src/config';
import { useAuth } from 'src/hooks/useAuth';

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [checked, setChecked] = useState<boolean>(false);

  const check = useCallback(() => {
    if (isAuthenticated) {
      const returnTo = `${URI_CONFIG.mainUrl}`;
      window.location.replace(returnTo);
    } else {
      setChecked(true);
    }
  }, [isAuthenticated]);

  // Only check on mount, this allows us to redirect the user manually when auth state changes
  useEffect(
    () => {
      check();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAuthenticated]
  );

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // not authenticated / authorized.

  return <>{children}</>;
};
